import axios from 'axios';

// Base API URL - Update this with your backend URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth API calls
export const authAPI = {
  sendOTP: async (phone) => {
    try {
      const response = await api.post('/auth/send-otp', { phoneNumber: phone });
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Failed to send OTP' };
    }
  },

  verifyOTP: async (phone, otp) => {
    try {
      const response = await api.post('/auth/verify-otp', { phoneNumber: phone, otpCode: otp });
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Failed to verify OTP' };
    }
  },

  completeSignup: async (name, email, token) => {
    try {
      const response = await api.put('/auth/profile', 
        { username: name, email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Failed to complete signup' };
    }
  },
};

export default api;

